module.exports = __webpack_public_path__ + "img/whatsapp.de7684bc.svg";